import React from 'react';
interface ClickPropsT {
  strokeColor?: string;
  fillColor?: string;
}
const Click = ({
  strokeColor,
  fillColor = 'none'
}: ClickPropsT) => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
      <rect width="1.98113" height="5.94578" transform="matrix(0.500302 -0.865851 0.866199 0.499698 0 9.16492)" fill={strokeColor ? strokeColor : 'currentColor'} />
      <rect width="1.98113" height="5.94578" transform="matrix(-0.500302 -0.865851 -0.866199 0.499698 22 9.16492)" fill={strokeColor ? strokeColor : 'currentColor'} />
      <rect width="1.98193" height="5.94339" transform="matrix(0.866199 -0.499698 0.500302 0.865851 3.96465 2.97107)" fill={strokeColor ? strokeColor : 'currentColor'} />
      <rect width="1.98193" height="5.94339" transform="matrix(-0.866199 -0.499698 -0.500302 0.865851 18.5665 2.97107)" fill={strokeColor ? strokeColor : 'currentColor'} />
      <rect x="9.91163" width="1.98232" height="5.94219" fill={strokeColor ? strokeColor : 'currentColor'} />
      <path fillRule="evenodd" clipRule="evenodd" d="M10.6275 10.6189V22.0103L13.4777 19.1625L15.8528 23.9089C15.8528 23.9089 16.4953 24.1137 16.8028 23.9089C17.1104 23.704 17.4162 23.2915 17.2779 22.9596C16.6245 21.3929 14.9027 18.2132 14.9027 18.2132H18.2279L10.6275 10.6189Z" fill={strokeColor ? strokeColor : 'currentColor'} />
    </svg>;
};
export { Click };